<template>
    <nav @keydown.escape="open = false">
        <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="border-b border-gray-700">
                <div class="flex items-center justify-between h-16 px-4 sm:px-0">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <img
                                class="w-8 h-8 cursor-pointer"
                                src="/img/mb_logo.png"
                                alt="Workflow logo"
                                @click="back"
                            />
                        </div>
                        <div class="hidden md:block">
                            <nav-links class="flex items-baseline ml-10">
                            </nav-links>
                        </div>
                    </div>
                    <div class="hidden md:block">
                        <div class="flex items-center ml-4 md:ml-6">
                            <div class="relative">
                                <div>
                                    <button
                                        @click="open = !open"
                                        class="flex items-center max-w-xs text-sm text-white rounded-full focus:outline-none focus:shadow-solid"
                                        id="user-menu"
                                        aria-label="User menu"
                                        aria-haspopup="true"
                                        aria-expanded="open"
                                    >
                                        <img
                                            class="w-12 h-12 rounded-full"
                                            :src="`/img/${user.username}.jpg`"
                                            alt=""
                                        />
                                    </button>
                                </div>
                                <transition v-enter="'transition ease-out duration-100'">
                                    <div
                                        v-show="open"
                                        x-transition:enter-start="transform opacity-0 scale-95"
                                        x-transition:enter-end="transform opacity-100 scale-100"
                                        x-transition:leave="transition ease-in duration-75"
                                        x-transition:leave-start="transform opacity-100 scale-100"
                                        x-transition:leave-end="transform opacity-0 scale-95"
                                        class="absolute right-0 w-48 mt-2 origin-top-right rounded-md shadow-lg"
                                    >
                                        <div class="py-1 bg-white rounded-md shadow-xs">
                                            <a
                                                href="#"
                                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >Profilo</a>
                                            <a
                                                href="#"
                                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >Impostazioni</a>
                                            <a
                                                href="#"
                                                @click="logout"
                                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >Logout</a>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div class="flex -mr-2 md:hidden">
                        <button
                            @click="open = !open"
                            class="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
                            :aria-label="open ? 'Close main menu' : 'Main menu'"
                            :aria-expanded="open"
                        >
                            <svg
                                class="w-6 h-6"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    :class="{
                                        hidden: open,
                                        'inline-flex': !open
                                    }"
                                    class="inline-flex"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                                <path
                                    :class="{
                                        hidden: !open,
                                        'inline-flex': open
                                    }"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <nav-bar-mobile
            :open="open"
            @logout="logout"
        ></nav-bar-mobile>
    </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import NavBarMobile from "./NavBarMobile";
import NavLinks from "./NavLinks";

export default {
    data: () => {
        return {
            open: false
        };
    },
    components: {
        NavBarMobile,
        NavLinks
    },
    computed: {
        ...mapState("app", ["user"])
    },
    methods: {
        ...mapGetters("app", ["group"]),
        back() {
            this.$router.go(-1);
        },
        logout() {
            this.$store
                .dispatch("auth/LOGOUT")
                .then(success => this.$router.push("/login"));
        }
    }
};
</script>
